export const AlertTypes = window.SIMBAR.alert_types;
export const AlertLevels = window.SIMBAR.alert_levels;
export const AlertCategories = window.SIMBAR.alert_categories;
export const Sources = window.SIMBAR.sources;
export const PRISMS_Y_AXES = window.SIMBAR.prisms.y_axes;
export const LimitConditions = window.SIMBAR.limit_conditions;
export const SensorReadingKind = window.SIMBAR.sensor_reading_kinds;
